/**
 * Created by Administrator on 2017/8/17.
 */
class global {
  /***
   * 首字母转大写
   */
  static setUpperCase(str) {
    let strArr = str.split('');
    strArr[0] = strArr[0].toUpperCase();
    return strArr.join('');
  }

  /***
   * unix time to yyyy-mm-dd hh:min:ss
   * @param date
   * @param type
   * @returns {*}
   */
  static formatDate(date, type) {
    try {
      let d = new Date(date), //(date instanceof Number) ? new Date(date) : date,
        yyyy = d.getFullYear(),
        mm = ('0' + (d.getMonth() + 1)).slice(-2),	// Months are zero based. Add leading 0.
        dd = ('0' + d.getDate()).slice(-2),			// Add leading 0.
        hh = ('0' + d.getHours()).slice(-2),
        min = ('0' + d.getMinutes()).slice(-2),
        ss = ('0' + d.getSeconds()).slice(-2),
        time;
      switch (parseInt(type)) {
        case 1:
          time = yyyy + '-' + mm + '-' + dd + ' ' + hh + ':' + min + ':' + ss;
          break;
        case 2:
          time = yyyy + '-' + mm + '-' + dd + ' ' + hh + ':' + min + ':00';
          break;
        case 3:
          time = yyyy + '-' + mm + '-' + dd + ' ' + hh + ':00:00';
          break;
        case 4:
          time = yyyy + '-' + mm + '-' + dd;
          break;
        default:
          time = yyyy + '-' + mm + '-' + dd;
      }
      return time;
    } catch (e) {
      console.log(e);
    }
  }

  static getAnotherDate(localTime, zone, type) {
    let local = '';
    try {
      let unix = new Date(localTime).getTime() + zone; //增减时间
      local = this.formatDate(unix, type);
    } catch (e) {
      console.log(e);
    }
    return local;
  }

  static daysOfWeek() {
    return 7;
  }

  static daysOfMonth(localTime, minus) {
    try {
      let days = null,
        year = new Date(localTime).getYear(),
        month = parseInt(new Date(localTime).getMonth()) + 1;
      month = minus ? month - 1 : month;
      switch (month) {
        case 1:
        case 3:
        case 5:
        case 7:
        case 8:
        case 10:
        case 12:
          days = 31;
          break;
        case 2:
          days = year % 4 === 0 && year % 100 !== 0 || year % 400 === 0 ? 29 : 28;
          break;
        case 4:
        case 6:
        case 9:
        case 11:
          days = 30;
          break;
      }
      return days;
    } catch (e) {
      console.log(e);
    }
  }

  static daysOfYear(localTime) {
    try {
      let year = new Date(localTime).getFullYear();
      return ((year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0)) ? 366 : 365;
    } catch (e) {
      console.log(e);
    }
  }

  static toFixed(data, num = 2, unit) {
    if (data && data !== 0) {
      if (unit) {
        return parseFloat((data * unit).toFixed(num));
      }
      return parseFloat(data.toFixed(num));
    }
    return data;
  }

  static remove(val, arr) {
    let index = arr.indexOf(val);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  }

  static globalHighChartOptions() {
    return {
      global: {useUTC: false},
      lang: {
        months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
        shortMonths: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        weekdays: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
        rangeSelectorZoom: "范围",
        rangeSelectorFrom: '从',
        rangeSelectorTo: '到',
        printChart: '打印图表',
        downloadJPEG: '导出 JPEG',
        downloadPDF: '导出 PDF',
        downloadPNG: '导出 PNG',
        downloadSVG: '导出 SVG'
      }
    };
  }

  static decodeChartData(data, csv_keys, scales) {
    console.time("chart data decode");

    let series = data.series;
    let keys = csv_keys.split(",");
    let pgKey = keys[0];

    let objList = [];

    for (let item of series) {
      let itemName = item.name;
      for (let itemDataI of item.data) {
        let obj = {};
        obj[pgKey] = itemName;
        objList.push(obj);
      }
    }

    for (let j=1, n=keys.length; j<n; ++j) {
      let i=-1;
      for (let item of series) {
        for (let itemData of item.data) {
          objList[++i][keys[j]] = itemData[-1+j];
        }
      }
    }

    if (scales) {
      for (let i=0, n=scales.length; i<n; ++i) {
        let scaleItem = scales[i];
        let scaleKey = scaleItem.key;
        let scaleValue = scaleItem.value;
        for (let j=0, m=objList.length; j<m; ++j) {
          let obj = objList[j];
          obj[scaleKey] = obj[scaleKey] * scaleValue;
        }
      }
    }

    console.timeEnd("chart data decode");

    return objList;
  }

  static str_cmp(a, b, reverse=false) {
    let arrA = a.split(/(\d+)/);
    if (null === a.match(/^\d+/)) {
      arrA.unshift("0");
    }

    let arrB = b.split(/(\d+)/);
    if (null === b.match(/^\d+/)) {
      arrB.unshift("0");
    }

    if (reverse) {
      arrA.reverse();
      arrB.reverse();
    }

    let lenA = arrA.length;
    let lenB = arrB.length;
    let end = Math.max(lenA, lenB);
    let i = -1;
    while (++i<end) {
      if (i < lenA && i < lenB) {
        let valA = arrA[i];
        let valB = arrB[i];

        if (0 === i % 2) {
          valA = Number(valA);
          valB = Number(valB);
        }

        if (valA !== valB) {
          return valA < valB ? -1 : 1;
        }
      } else {
        return lenA < lenB ? -1 : 1;
      }
    }
    return 0;
  }
  static filter(data, cb) {
    let _data = [];
    for (let d of data) {
      if (cb(d)) {
        _data.push(d);
      }
    }
    return _data;
  }
  static group_by(data, csv_keys) {
    let keys = csv_keys.split(",");
    let lenKeys = keys.length;
    for (let i=0; i<lenKeys; ++i) {
      keys[i] = keys[i].trim();
    }
    let eok = lenKeys-1;
    let map = {};
    for (let d of data) {
      let _node = map;
      for (let i=0; i<lenKeys; ++i) {
        let key = keys[i];
        let value = d[key];
        if (i === eok) {
          if (_node.hasOwnProperty(value)) {
            _node[value].push(d);
          } else {
            _node[value] = [d];
          }
        } else {
          _node[value] = {};
        }
        _node = _node[value];
      }
    }
    return map;
  }
  /***
   * 对url进行编码
   */
   static encodeUrl(str) {
    return encodeURIComponent(str) === 'undefined' ? '' : encodeURIComponent(str);
  }

  static toAjaxResult(body) {
    let code;
    let msg;
    let data = null;
    if (body.hasOwnProperty("code")) {
      code = body.code;
      msg = body.msg;
      data = body.data;
    } else if (body.hasOwnProperty("MESSAGE")) {
      if (body.MESSAGE === "success") {
        // TODO: 暂时兼容老版本的响应体
        code = 0;
        msg = body.MESSAGE;
      } else {
        // TODO: 暂时兼容老版本的响应体
        code = 1;
        msg = body.MESSAGE;
      }
    } else if (body.hasOwnProperty("errcode")) {
      // TODO: 暂时兼容老版本的响应体
      code = body.errcode;
      if (typeof(code) === "string") {
        code = parseInt(code);
      }
      if (200 === code) {
        code = 0;
      }
      msg = body.meesage;
      data = body.data;
    } else {
      code = 1;
      msg = "未知错误";
    }
    return {code,msg,data};
  }

  /**
   * @param {[]} arr [输入|输出] 被排序数组
   * @param {String[]} fields 排序字段数组
   * @param {Number[]} orders 顺序数组，数组长度与fields参数长度一致，表示各个字段的排序方式，1表示升序，-1表示降序
   */
  static sort(arr, fields, orders) {
    let len = fields.length;
    arr.sort((o1, o2)=>{
      for (let i=0; i<len; ++i) {
        let field = fields[i];
        let v1 = o1[field];
        let v2 = o2[field];
        if (v1 !== v2) {
          return v1 < v2 ? -1 * orders[i] : orders[i];
        }
      }
      return 0;
    });
  }

  /**
   *
   * @param {Object} vueObj
   * @param {String} html
   */
  static showOperateConfirm(vueObj, html) {
    let str = 'qwertyuiopasdfghjklzxcvbnm0123456789';
    let yzm = '';
    for(let i = 0; i <= 3; i++) {
      let item = parseInt(Math.random()*(str.length) - 0);
      yzm += str[item];
    }
    return vueObj.$prompt(`<div>${html}</div>请输入验证码<i class="yzm"
            style="color:red;display:inline-block;height:30px;line-height:30px;text-align:center;width:60px;
            background:#ccc;font-size:18px;margin-left:10px">${yzm}</i>`, '提示', {
      dangerouslyUseHTMLString: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      showInput: true,
      customClass: 'messageBox',
      inputErrorMessage: '验证码不正确',
      inputValidator: (value)=> {
        if(value === '' || value !== yzm) {
          return false;
        }
      }
    });
  }
}

export default global;



// WEBPACK FOOTER //
// ./src/managers/utils/global-tool.js